import { Link } from 'react-router-dom';
import { heroContent } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative h-[420px] md:h-[600px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20community%20gathering%20of%20diverse%20Malaysian%20youth%20in%20bright%20modern%20community%20center%2C%20learning%20and%20collaborating%20together%2C%20natural%20sunlight%20streaming%20through%20large%20windows%2C%20uplifting%20and%20hopeful%20atmosphere%2C%20soft%20warm%20amber%20and%20cream%20tones%2C%20shallow%20depth%20of%20field%2C%20editorial%20documentary%20photography%20style&width=1800&height=900&seq=hero-main-2026&orientation=landscape"
          alt="Youth community program at PERTUBUHAN INSAN PERWIRA PULAU PINANG"
          title="PERTUBUHAN INSAN PERWIRA PULAU PINANG - Youth Empowerment"
          className="w-full h-full object-cover object-top"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/55"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-5 md:mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-400"></span>
              <span className="text-background-50 text-xs md:text-sm font-medium">
                NGO · Pulau Pinang · Since 2020
              </span>
            </div>
            <h1 className="font-heading font-bold text-3xl md:text-5xl lg:text-6xl text-background-50 leading-tight mb-4 md:mb-5">
              {heroContent.title}
            </h1>
            <p className="text-background-50/80 text-sm md:text-base leading-relaxed mb-6 md:mb-8 max-w-xl">
              {heroContent.subtitle}
            </p>
            <div className="flex flex-col sm:flex-row items-start gap-3">
              <Link
                to="/donation"
                className="px-7 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm transition-all duration-200 whitespace-nowrap flex items-center gap-2"
              >
                {heroContent.cta}
                <i className="ri-arrow-right-line"></i>
              </Link>
              <a
                href="#about"
                className="px-7 py-3 rounded-full border border-background-50/30 hover:border-background-50/60 text-background-50 font-semibold text-sm transition-all duration-200 whitespace-nowrap"
              >
                {heroContent.secondaryCta}
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 hidden md:block">
        <div className="w-5 h-8 rounded-full border-2 border-background-50/30 flex items-start justify-center p-1">
          <div className="w-1 h-2 rounded-full bg-background-50/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}